module.exports = __webpack_public_path__ + "static/media/banner-comunicado-rs.ed1e5048.png";